<template>
  <v-dialog :value="value" v-on:input="$emit('input',$event)" :width="width" persistent>
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
      <v-btn :class="classBtn" :small="small" color="primary" v-if="textBtn" v-on="on">{{textBtn}}</v-btn>
      <v-icon size="medium" :class="classBtn" v-if="icon" v-on="on">{{icon}}</v-icon>
    </template>

    <v-card>
      <v-card-title  primary-title>
        {{title}}
        <v-spacer />
        <v-icon v-if="closable" @click="$emit('input',false)">fas fa-times</v-icon>
      </v-card-title>

      <v-card-text class="py-0">
        <slot name="content"></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "Dialog",

  props: {
    value: Boolean,
    closable: Boolean,
    width: {
      type: Number,
      default: 350,
    },
    textBtn: {
      type: String,
    },
    title: {
      type: String,
    },
    classBtn: {
      type: String,
    },
    icon: {
      type: String,
    },
    textNo: {
      type: String,
    },
    textYes: {
      type: String,
    },
    colorTextYes: {
      type: String,
    },
    small: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
};
</script>
